// extracted by mini-css-extract-plugin
module.exports = {"container":"video-m__container__7lqFj"};